import { Button, color, Flex, Text, useColorMode } from 'deepstash-ui';
import useRouter from 'hooks/useRouter';
import React, { useEffect } from 'react';
import LayoutAdapter from 'src/components/layout/LayoutAdapter';
import NextLink from 'src/components/navigation/NextLink';
import { Analytics, Events } from 'src/services/analytics';
import { typography } from 'theme';
import { getErrorPageMetadata } from 'utils/metadata.utils';

const ErrorPage = () => {
  const { colorMode } = useColorMode();

  const router = useRouter();

  useEffect(() => {
    Analytics.logEvent({
      eventName: Events.stability.errorPage,
      properties: {
        path: router.asPath,
      },
      platforms: ['amplitude'],
    });
  }, []);

  return (
    <LayoutAdapter pageMetadata={getErrorPageMetadata()}>
      <Flex
        flexDir={{ base: 'column', lg: 'row' }}
        mt={{ base: '0', lg: '125px' }}
        align="center"
      >
        <Flex flexDirection="column" w="50%">
          <Text
            fontSize="60px"
            fontWeight="300"
            color={color[colorMode].textDisabled}
          >
            404
          </Text>
          <Text
            mb="10px"
            {...typography.articleTitle}
            color={color[colorMode].text}
          >
            {router.asPath.includes('/u/') ? 'User' : 'Page'} Not Found
          </Text>
          <Text mb="60px" color={color[colorMode].text}>
            The page you are looking for was moved, removed, renamed or may have
            never existed.
          </Text>
          <NextLink href="/">
            <Button
              w="150px"
              px="20px"
              backgroundColor={color[colorMode].primary.default}
              color={color[colorMode].surface}
              _active={{ backgroundColor: color[colorMode].primary.darker }}
              _focus={{ outline: 'none' }}
              borderRadius={20}
              outline="none"
              mr="20px"
              mb="20px"
              fontSize="16px"
            >
              Go Home
            </Button>
          </NextLink>
        </Flex>
      </Flex>
    </LayoutAdapter>
  );
};

export default ErrorPage;
